import { FC, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import LightTwoColsHeader from '~src/shared/headers/lightTwoColsHeader/LightTwoColsHeader';
import PrimaryButton from '~src/shared/buttons/basicButtons/PrimaryButton.sc';
import { useScrollHeader } from '~src/services/hooks/useScrollHeader';
import { StoreI } from '~src/rootReducer';
import { MediaTypes } from '~src/styles/media-templates';
import { routes } from '~src/routingConfig';

import { PlusSymbol, TableHeader, HeaderContainer, AddObjectiveLnk } from './header.sc';
import { NameCol, OwnersCol, DueDateCol, StatusCol, ProgressCol, LabelsCol } from './shared.sc';
import FiltersSection from './filtersSection/FiltersSection';
import { FiltersContext } from './ObjectivesOverview';

interface StateProps {
  media?: MediaTypes;
}

interface Props {
  isNoObjectives: boolean;
}

const Header: FC<Props & StateProps> = props => {
  const [t] = useTranslation();
  const headerRef = useRef<HTMLDivElement>(null);
  const { smallHeader } = useScrollHeader(headerRef, undefined, 1);
  const filtersContext = useContext(FiltersContext);
  const isMobile = props.media !== 'desktop';
  const hideFilters =
    filtersContext.filterObj && Object.keys(filtersContext.filterObj).length <= 1 && props.isNoObjectives;

  return (
    <HeaderContainer ref={headerRef}>
      <LightTwoColsHeader
        smallHeader={smallHeader}
        withBorder
        title={{ key: 'x.okr.objectives.header.title' }}
        descr={{ key: 'x.okr.objectives.header.description' }}
      >
        <AddObjectiveLnk to={routes.okrs.add} $smallHeader={smallHeader}>
          <PrimaryButton $buttonSize={isMobile ? 'medium' : 'wide'}>
            <PlusSymbol>+</PlusSymbol> {t('x.okr.objectives.header.new_objective_button')}
          </PrimaryButton>
        </AddObjectiveLnk>
      </LightTwoColsHeader>
      {hideFilters ? null : <FiltersSection />}
      <TableHeader $isHidden={props.isNoObjectives}>
        <NameCol>{t('x.okr.objectives.header.name_col')}</NameCol>
        <ProgressCol>{t('x.okr.objectives.header.progress_col')}</ProgressCol>
        <StatusCol>{t('x.okr.objectives.header.status_col')}</StatusCol>
        <DueDateCol>{t('x.okr.objectives.header.due_date_col')}</DueDateCol>
        <OwnersCol>{t('x.okr.objectives.header.owners_col')}</OwnersCol>
        <LabelsCol>{t('x.okr.objectives.header.labels_col')}</LabelsCol>
      </TableHeader>
    </HeaderContainer>
  );
};

const mapState2Props = ({ app }: StoreI): StateProps => ({
  media: app.mediaQuery,
});

export default connect(mapState2Props)(Header);
